module.exports = __webpack_public_path__ + "static/media/1Asset-5Subscription.03031495.png";